<template>
  <div
    :id="id"
    :class="`Collapse has-icon` + (isExpanded ? ' is-open' : '')"
    data-toggle-icon=".Icon"
  >
    <h3 class="Collapse-heading Collapse-label--divider u-pad03">
      <button
        class="Collapse-button"
        type="button"
        :aria-expanded="isExpanded"
        @click="toggleCollapse"
      >
        <span class="u-flex u-flexJustifyBetween u-flexAlignItemsCenter">
          <span>
            <slot name="label"></slot>
          </span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-hidden="true"
            class="Icon Icon--block Collapse-icon u-textShrink2"
            :class="isExpanded ? ' is-on' : ''"
            focusable="false"
            role="presentation"
          >
            <path
              :class="isExpanded ? 'Icon-rotateCounter1of8' : ''"
              d="M22,13.5H2a1.5,1.5,0,0,1,0-3H22a1.5,1.5,0,0,1,0,3Z"
            />
            <path
              :class="isExpanded ? 'Icon-rotateCounter1of8' : ''"
              d="M12,23.5A1.50007,1.50007,0,0,1,10.5,22V2a1.5,1.5,0,0,1,3,0V22A1.50039,1.50039,0,0,1,12,23.5Z"
            />
          </svg>
        </span>
      </button>
    </h3>
    <div class="Collapse-content u-padSides03 u-padEnds3 u-borderTop" :hidden="!isExpanded">
      <div class="Prose u-spaceItems3">
        <slot name="content"></slot>
      </div>
    </div>
    <slot name="removeButton"></slot>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useFormStore } from '../stores/formStore'

const formStore = useFormStore()

const props = defineProps({
  // The current value of the input (used with v-model)
  id: {
    type: String,
    default: '',
  },
  // Initial state of the collapse (expanded or collapsed)
  initiallyExpanded: {
    type: Boolean,
    default: true,
  },
})

// Reactive state for collapse expansion
const isExpanded = ref(props.initiallyExpanded)

// Toggle function
const toggleCollapse = () => {
  isExpanded.value = !isExpanded.value
}

// Expose methods for parent components if needed
defineExpose({
  toggle: toggleCollapse,
  expand: () => {
    isExpanded.value = true
  },
  collapse: () => {
    isExpanded.value = false
  },
  isExpanded,
})
</script>

<style scoped>
.Collapse-content {
  border-color: rgba(0, 0, 0, 0.15);
}
</style>
